module.exports = __webpack_public_path__ + "static/media/createFolder.03085d7a.svg";